import http from 'src/http/fetchClient';
import CONTENT_TYPES from './contentTypes';

class ProviderService {
  getProviders = async (page, size, orderBy, order, status, searchTerm, providerIds) => {
    try {
      const response = await http.get('/api/admin/providers', {
        headers: {
          'Content-Type': CONTENT_TYPES.products_provider
        },
        data: {},
        params: {
          page,
          size,
          orderBy,
          order,
          status,
          searchTerm,
          providerIds
        }
      });

      return response.data;
    } catch (error) {
      return error.response;
    }
  };

  getProvidersByIds = async (providerIds) => {
    try {
      const response = await http.get('/api/admin/providers', {
        headers: {
          'Content-Type': CONTENT_TYPES.products_provider
        },
        data: {},
        params: { providerIds: providerIds.reduce((f, s) => `${f},${s}`, '') }
      });
      return response.data;
    } catch (error) {
      return error.response;
    }
  };

  getPermittedProviders = async () => {
    try {
      const response = await http.get('/api/admin/providers/permitted', {
        headers: {
          'Content-Type': CONTENT_TYPES.products_provider
        },
        data: {}
      });

      return response.data.providers;
    } catch (error) {
      throw new Error(error.response.data.errorMessage);
    }
  };

  getProvider = async (id) => {
    try {
      const response = await http.get(`/api/admin/providers/${id}`, {
        headers: {
          'Content-Type': CONTENT_TYPES.products_provider
        },
        data: {}
      });

      return response.data;
    } catch (error) {
      return error.response;
    }
  };

  addProvider = async (
    name,
    code,
    balance,
    threshold,
    fiatCurrencyId,
    status,
    highRisk,
    uploadReport,
    overrideDiscountPointRewardRate,
    discountPointRewardRate,
    fulfilmentChannelId
  ) => {
    try {
      const response = await http.post(
        '/api/admin/providers',
        {
          name,
          code,
          balance,
          threshold,
          fiatCurrencyId,
          status,
          highRisk,
          uploadReport,
          overrideDiscountPointRewardRate,
          discountPointRewardRate,
          fulfilmentChannelId
        },
        {
          headers: {
            'Content-Type': CONTENT_TYPES.products_provider
          }
        }
      );

      return response;
    } catch (error) {
      throw new Error(error.response.data.errorMessage);
    }
  };

  updateProvider = async (
    id,
    name,
    code,
    balance,
    threshold,
    fiatCurrencyId,
    status,
    highRisk,
    uploadReport,
    overrideDiscountPointRewardRate,
    discountPointRewardRate,
    fulfilmentChannelId
  ) => {
    try {
      const response = await http.put(
        `/api/admin/providers/${id}`,
        {
          name,
          code,
          balance,
          threshold,
          fiatCurrencyId,
          status,
          highRisk,
          uploadReport,
          overrideDiscountPointRewardRate,
          discountPointRewardRate,
          fulfilmentChannelId
        },
        {
          headers: {
            'Content-Type': CONTENT_TYPES.products_provider
          }
        }
      );

      return response;
    } catch (error) {
      throw new Error(error.response.data.errorMessage);
    }
  };

  toggleProviderStock = async (provider) => {
    try {
      return http.put(
        `/api/admin/providers/stock/${provider.id}`,
        {
          inStock: !provider.inStock
        },
        {
          headers: {
            'Content-Type': CONTENT_TYPES.products_provider
          }
        }
      );
    } catch (error) {
      return error.response;
    }
  };

  deleteProvider = async (id) => {
    try {
      return http.delete(`/api/admin/providers/${id}`, {
        headers: {
          'Content-Type': CONTENT_TYPES.products_provider
        },
        data: {}
      });
    } catch (error) {
      return error.response;
    }
  };

  refreshProviderBalance = async (id) => {
    try {
      return http.post(
        `/api/admin/providers/${id}/balance`,
        {},
        {
          headers: {
            'Content-Type': CONTENT_TYPES.products_provider
          }
        }
      );
    } catch (error) {
      return error.response;
    }
  };
}

const providerService = new ProviderService();

export default providerService;
